export const API_KEY = '28318b77967fcb148715c1c7fa524b54';

export const WATCHED_STORAGE_KEY = 'movies-watched';
export const QUEUE_STORAGE_KEY = 'movies-in-queue';
